import React from "react";
import { Link as ScrollLink } from "react-scroll";

const aboutData = {
  cvpath: "media/keirmacdonaldcv.pdf",
  image: "images/about.png",
  name: "Keir MacDonald",
  location: "Oxfordshire, England",
  availability: "Evaluating opportunities",
  email: "keir@kamd.me.uk",
  aboutMe:
    "I'm a software engineer from the south of Oxfordshire, developing web applications for the cloud and focusing on backend. I build performant and maintainable systems, and enjoy helping colleagues do the same. Here I am pictured in a ball pit, but for work purposes I am usually sat at a desk.",
};

function About() {
  return (
    <div className="row">
      <div className="col-md-3">
        <img src={aboutData.image} alt={aboutData.name} />
      </div>
      <div className="col-md-9">
        <h2 className="mt-4 mt-md-0 mb-4">Hello,</h2>
        <p className="mb-0">{aboutData.aboutMe}</p>
        <div className="row my-4">
          <div className="col-md-6">
            <p className="mb-2">
              Name: <span className="text-dark">{aboutData.name}</span>
            </p>
            <p className="mb-0">
              Availability: <span className="text-dark">{aboutData.availability}</span>
            </p>
          </div>
          <div className="col-md-6 mt-2 mt-md-0 mt-sm-2">
            <p className="mb-2">
              Location: <span className="text-dark">{aboutData.location}</span>
            </p>
            <p className="mb-0">
              Email: <span className="text-dark">{aboutData.email}</span>
            </p>
          </div>
        </div>
        <a href={aboutData.cvpath} className="btn btn-default mr-3">
          <i className="icon-cloud-download"></i>Download CV
        </a>
        <ScrollLink
          activeClass="active"
          to="section-contact"
          spy={true}
          smooth={true}
          duration={500}
          offset={50}
          className="btn btn-alt mt-2 mt-md-0 mt-xs-2"
        >
          <i className="icon-envelope"></i>Talk to me
        </ScrollLink>
      </div>
    </div>
  );
}

export default About;
